import { Button, Tag } from 'antd';
import React, { FC } from 'react'
import DocumentosService from '../api/Documentos/api-documentos';

interface InputDocProps {
    onDelete: () => void;
    on_change: (data) => void;
    doc: string;
    fileInputRef: any;
    tipos_doc?: string;
    setGuardoArchivo?: (data: boolean) => void
    ancho_btn?: number;

}

const DocumentInput: FC<InputDocProps> = ({ doc, fileInputRef, tipos_doc = 'PDF', on_change, setGuardoArchivo, onDelete, ancho_btn = 20 }) => {
    return (
        <>
            <div className="input-group">
                <div className="form-control">
                    {doc && (
                        <Tag
                            className="font-family-Montserrat-Regular mt-1"
                            closable={true}
                            onClose={async () => {
                                await DocumentosService.eliminarArchivo(
                                    doc
                                );
                                setGuardoArchivo && setGuardoArchivo(false);
                                onDelete();
                                // return setDocumento({
                                //     ...doc,
                                //     url_documento: "",
                                // });
                            }}
                            onClick={() => {

                            }}
                        >
                            {doc.length > 24 ? `${doc.split(".")[0].substring(0, 20)}.${doc.split(".")[1]}` : doc}

                        </Tag>
                    )}
                </div>
                <Button className="buttonblanco-radius-input" style={{ width: `${ancho_btn}%`, borderRadius: '6px' }} onClick={() => {
                    if (fileInputRef.current !== null) {
                        fileInputRef.current.click();
                    }
                }}
                >
                    Adjuntar
                </Button>

            </div>
            <div className="font-size-10px font-color-#707070 font-family-Montserrat-Regular">Tipo de archivo: {tipos_doc} Máx: 5MB.</div>
            <input
                ref={fileInputRef}
                type="file"
                hidden
                onChange={(e) => {
                    on_change(e);
                }}
            />
        </>
    )
}

export default DocumentInput